import { render, staticRenderFns } from "./Issues-Wise-chart.vue?vue&type=template&id=2c913878"
import script from "./Issues-Wise-chart.vue?vue&type=script&lang=js"
export * from "./Issues-Wise-chart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports